interface InlineImageSizeOptions {
  imageWidth: number;
  imageHeight: number;
  stageWidth: number;
  stageHeight: number;
  availableHeight: number;
}

interface Size {
  width: number;
  height: number;
}

export const getInlineImageSize = ({
  imageWidth,
  imageHeight,
  stageWidth,
  stageHeight,
  availableHeight,
}: InlineImageSizeOptions): Size => {
  const innerWidth = stageWidth > 0 ? stageWidth : imageWidth;
  const stageInnerHeight = stageHeight > 0 ? stageHeight : imageHeight;
  const innerHeight =
    availableHeight > 0
      ? Math.min(stageInnerHeight, availableHeight)
      : stageInnerHeight;
  const imageRatio = imageWidth / imageHeight;
  const maxWidthByHeight = innerHeight * imageRatio;
  const boundedWidth = Math.min(innerWidth, maxWidthByHeight);
  const boundedHeight = boundedWidth / imageRatio;

  return {
    width: Math.max(1, Math.floor(boundedWidth)),
    height: Math.max(1, Math.floor(boundedHeight)),
  };
};
